// Utility for fetch with automatic polyfill for test environments

let fetchPolyfillLoaded = false;

export async function fetchWithPolyfill(url: string, options?: RequestInit): Promise<Response> {
  // Ensure fetch is available
  if (!globalThis.fetch && !fetchPolyfillLoaded) {
    try {
      const { default: fetch, Headers, Request, Response } = await import('node-fetch');
      globalThis.fetch = fetch as any;
      globalThis.Headers = Headers as any;
      globalThis.Request = Request as any;
      globalThis.Response = Response as any;
      fetchPolyfillLoaded = true;
    } catch (error) {
      console.warn('Failed to load fetch polyfill:', error);
    }
  }

  return globalThis.fetch(url, options);
}